import Tooltips from 'components/tooltips/Tooltips';

// The box that ticks a task, in the colours of the admin's checkboxes. It
// keeps its click from opening the row it sits in. `disabledReason` says, in
// a tooltip, why a disabled box cannot be ticked.
const TaskCheckbox = ({ checked, disabled = false, disabledReason, label, onToggle }) => {
  const box = (
    <span className="flex" onClick={(event) => event.stopPropagation()}>
      <input
        type="checkbox"
        // A disabled box swallows the pointer: its wrapper gets the hover,
        // and with it the tooltip that says why.
        className="checkbox-primary disabled:pointer-events-none"
        checked={checked}
        disabled={disabled}
        aria-disabled={disabled}
        onChange={disabled ? () => {} : onToggle}
        aria-label={disabled && disabledReason ? disabledReason : label}
      />
    </span>
  );
  if (!disabled || !disabledReason) return box;
  return (
    // On its right: the box sits at the left edge of lists that clip.
    <Tooltips text={disabledReason} placement="right">
      {box}
    </Tooltips>
  );
};

export default TaskCheckbox;
